import { Article } from '@web/newsfeed/types/Article';
import { useParsedContent } from '@web/common/hooks/useParsedContent';

export function useArticle(article: Article) {
  const parsedContent = useParsedContent(article?.content || '', null);

  return {
    parsedContent,
  };
}
